import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import ModalManager from "../../sub/modals/ModalManager";
import {
  assignEquipment,
  checkIfEquipmentExists,
} from "../../../actions/equipments/equipments";
import Alert from "react-bootstrap/Alert";

class EquipmentAssignModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedEstablishmentId: null,
      disinfectionDate: null,
      modal: null,
    };
  }

  close() {
    this.props.closeModal();
  }

  // Establishment to which equipment will be linked to
  selectEstablishment = (establishmentId) => {
    this.setState({ selectedEstablishmentId: establishmentId });
  };

  // Set disinfection date
  setDisinfectionDate = (date) => {
    this.setState({ disinfectionDate: date });
  };

  // Do assign
  assignEquipment = (equipment, selectedEstablishmentId) => {
    this.props.onCheckIfEquipmentExists(
      {
        establishmentId: selectedEstablishmentId,
        internRef: equipment.internal_ref,
      },
      () => {
        this.openDataIntegrityModal(equipment.internal_ref);
      },
      () => {
        this.props.onAssignEquipment(this.props.equipment.company_id, {
          equipmentId: equipment._id,
          internalRef: equipment.internal_ref,
          establishmentId: selectedEstablishmentId,
          disinfectionDate: this.state.disinfectionDate,
        });
      },
    );
  };


  openDataIntegrityModal(internalRef) {
    let establishmentName = this.getEstablishmentName();

    let errorModalTitle = <FormattedMessage id="Error" />;
    let errorModalContent = (
      <div>
        <div className="alert alert-danger">
          <div>
            <FormattedMessage
              id="Equipment.Can.Not.Be.affected"
              values={{
                internalRef: internalRef,
                establishmentName: establishmentName,
              }}
            />
          </div>
        </div>
        <table className="table table-striped tablee4coll">
          <thead>
            <tr className="d-flex">
              <th scope="col" className="col col-3">
                <FormattedMessage id="Establishment" />
              </th>
              <th scope="col" className="col col-3">
                <FormattedMessage id="Intern.Ref" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="d-flex">
              <td className="col col-3">{establishmentName}</td>
              <td className="col col-3">{internalRef}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );

    this.props.openErrorModal(errorModalTitle, errorModalContent);
  }

  getEstablishmentName() {
    for (let establishment of this.props.establishments) {
      if (establishment._id === this.state.selectedEstablishmentId)
        return establishment.name;
    }
  }

  render() {
    let equipment = this.props.equipment;

    let establishmentsNode = this.props.establishments.map((establishment) => {
      return (
        <option key={establishment._id} value={establishment._id}>
          {establishment.name}
        </option>
      );
    });

    let content = (
      <div>
        <Alert variant="warning">
          <FormattedMessage id="Assign.Confirm.Message" />
        </Alert>
        <div className="mb-3">
          <label className="form-label">
            Sélectionnez un établissement
          </label>
          <select
            id="fleet-filter-establishmentId"
            className="form-control"
            onChange={(e) => this.selectEstablishment(e.target.value)}
          >
            <option key="" value="">
              {this.props.intl.formatMessage({
                id: "Select.Establishment",
              })}
            </option>
            {establishmentsNode}
          </select>
        </div>
        <div>
          <label className="form-label">
            Date de désinfection
          </label>
          <input
            type="date"
            className="form-control"
            value={this.state.disinfectionDate || ""}
            onChange={(e) => this.setDisinfectionDate(e.target.value)}
          />
        </div>
      </div>
    );

    let successCallback = () =>
      this.assignEquipment(equipment, this.state.selectedEstablishmentId);

    return (
      <ModalManager
        showModal={true}
        title={<FormattedMessage id="Assign.To.Establishment" />}
        content={content}
        successCallback={successCallback}
        closeModal={() => this.close()}
        modalType="confirmation"
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    establishments: state.establishments,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAssignEquipment: (companyId, data) =>
      dispatch(assignEquipment(companyId, data)),
    onCheckIfEquipmentExists: (data, existsCallback, noExistsCallback) =>
      dispatch(checkIfEquipmentExists(data, existsCallback, noExistsCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EquipmentAssignModal));
